import React, { memo, useState, useEffect } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import {
  ModalOverlay,
  ModalContainer,
  ModalHeader,
  ModalTitle,
  CloseButton,
} from "./Modal.elements";
import { hideModal } from "../../redux/modal";
import { ModalState } from "../../redux/modal/modal.slice";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";

interface ModalProps extends WithTranslation {}

interface RootState {
  modal: ModalState;
}

export function Modal({ t }: ModalProps) {
  const dispatch = useDispatch();
  const { isVisible, title, content } = useSelector(
    (state: RootState) => state.modal
  );
  const [shouldRender, setShouldRender] = useState(false);
  const [isVisibleState, setIsVisibleState] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true);
    } else if (shouldRender) {
      setIsVisibleState(false);
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [isVisible, shouldRender]);

  useEffect(() => {
    if (shouldRender) {
      const timer = setTimeout(() => {
        setIsVisibleState(true);
      }, 10);
      return () => clearTimeout(timer);
    } else {
      setIsVisibleState(false);
    }
  }, [shouldRender]);

  const handleClose = () => {
    dispatch(hideModal());
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  if (!shouldRender) {
    return null;
  }

  return (
    <ModalOverlay onClick={handleOverlayClick} $isClosing={!isVisibleState}>
      <ModalContainer $isClosing={!isVisibleState}>
        <ModalHeader>
          {title && <ModalTitle>{title}</ModalTitle>}
          <CloseButton onClick={handleClose}>
            <CloseIcon />
          </CloseButton>
        </ModalHeader>
        {content}
      </ModalContainer>
    </ModalOverlay>
  );
}

export default withTranslation()(memo(Modal));
